import { ENV } from "common/constants";

/**
 * 生产环境禁用工具调试。
 */
export default (): void => {
  if (["local", "dev"].indexOf(ENV) > -1) {
    return;
  }
  const DEV_TOOLS = (window as any).__REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (typeof(DEV_TOOLS) === "object" && Object.keys(DEV_TOOLS).length) {
    for (const [key, value] of Object.entries(DEV_TOOLS)) {
      DEV_TOOLS[key] = typeof(value) === "function" ? () => undefined : null;
    }
  } 
};
